<template>
  <div class="check_page page">
    <Stage :navNum="3" />
    <div class="system_box">
      <span class="title">账号转移平台确认</span>
      <div class="system_info">
        <div class="system_1">{{ $parent.system == 1 ? '苹果' : '安卓' }}</div>
        <i class="transform_icon"></i>
        <div class="system_2">{{ $parent.system == 1 ? '安卓' : '苹果' }}</div>
      </div>
    </div>
    <div class="check_box">
      <span class="title">请检测您的账号是否符合转移要求</span>
      <div class="check_btn" v-if="!checkLoading" @click="checkAccount">
        账号检测
      </div>
      <div class="check_loading" v-else>
        <i class="circle"></i>
      </div>
      <div class="check_list">
        <span class="end_text" v-if="checked && checkOk"
          >检测结果:账号符合条件，可转移</span
        >
        <span class="end_text" v-if="checked && !checkOk"
          >检测结果：账号有{{ countStatusOne }}项未符合条件，请处理</span
        >
        <div class="check_item" v-for="(item, index) in checkList" :key="index">
          <span>{{ item.text }}</span>
          <i :class="`check_status status_${item.status}`"></i>
        </div>
      </div>
    </div>
    <div class="btn_box">
      <div class="pre_btn" @click="$parent.currentPage--">上一步</div>
      <div
        :class="`next_btn ${checked && checkOk ? '' : 'no_next'}`"
        @click="nextStep"
      >
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import { getCheck } from '../api/index';
import Stage from './childcomponents/Stage.vue';
export default {
  components: {
    Stage
  },
  data() {
    return {
      checked: false,
      checkOk: false,
      checkLoading: false,
      checkList: [
        {
          text: '1、转移账号未处于封停状态',
          status: 0
        },
        {
          text: '2、转移账号距离上次转移时间＞12小时',
          status: 0
        },
        {
          text: '3、转移账号未处于退款补缴状态',
          status: 0
        },
        {
          text: '4、转移账号未进行过渠道转入官方的操作',
          status: 0
        },
        {
          text: '5、转移账号未进行过跨系统账号转移以外的转移服务',
          status: 0
        }
      ]
    };
  },
  computed: {
    countStatusOne() {
      return this.checkList.filter((item) => item.status === 2).length;
    }
  },
  watch: {},
  methods: {
    checkAccount() {
      this.checkLoading = true;
      let t = new Date().getTime();
      getCheck({
        appkey: 1486458782785,
        type: this.$parent.system,
        sign: this.$md5(
          t +
            this.$md5(1486458782785 + this.$parent.userid) +
            'UIwf 8-08e30P)*_)@$e;l23r'
        ),
        userid: this.$parent.userid,
        t: t,
        token: this.$parent.token,
        deviceid: this.$parent.deviceId,
        cert: this.$parent.cert
      }).then((res) => {
        console.log(res);
        if (res.data.data.success) {
          this.checked = true;
          // this.transinNum = res.data.data.list.length;
          let info = res.data.data.info;
          this.$parent.payToken = info.token;
          this.checkList.forEach((item, index) => {
            if (info[`condition${index + 1}`] == 1) {
              item.status = 1;
            } else {
              item.status = 2;
            }
          });
          this.checked = true;
          let i = 0;
          this.checkList.forEach((item) => {
            if (item.status == 2) {
              this.checkOk = false;
            } else {
              i++;
            }
            if (i == 5) {
              this.checkOk = true;
            }
          });
        } else if (res.data.data.code == 429) {
          this.$parent.getTip(`操作频繁`);
        } else {
          this.$parent.getTip(`账号检测失败--${res.data.data.code}`);
        }
        this.checkLoading = false;
      });
    },
    nextStep() {
      if (this.checked && this.checkOk) {
        this.$parent.currentPage++;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.system_box {
  flex-shrink: 0;
  width: 100%;
  height: 2.88rem;
  background: #feffff;
  .layout-flex(@col,normal,@c);
  margin: 0.36rem 0;
  .title {
    width: 100%;
    font-weight: 500;
    color: #1b1919;
    font-size: 0.28rem;
    padding-left: 0.32rem;
    margin-top: 0.47rem;
    margin-bottom: 0.39rem;
    box-sizing: border-box;
  }
  .system_info {
    width: 4.07rem;
    height: 1.14rem;
    display: flex;
    justify-content: space-between;
    .system_1,
    .system_2 {
      width: 1.14rem;
      height: 1.14rem;
      border-radius: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 0.32rem;
    }
    .system_1 {
      background: #e8f1fc;
      color: #3e73fe;
    }
    .transform_icon {
      width: 1.11rem;
      height: 0.46rem;
      background: url('../assets/transform_icon.png');
      background-size: 100% 100%;
      transform: translateY(0.2rem);
    }
    .system_2 {
      background: #e6f9e5;
      color: #67b66b;
    }
  }
}
.check_box {
  flex-shrink: 0;
  margin-top: 0.36rem;
  width: 100%;
  height: 7.02rem;
  background: #feffff;
  .layout-flex(@col,normal,@c);
  .title {
    width: 100%;
    font-weight: 500;
    color: #1b1919;
    font-size: 0.28rem;
    padding-left: 0.32rem;
    margin-top: 0.48rem;
    margin-bottom: 0.4rem;
    box-sizing: border-box;
  }
  .check_btn {
    width: 3.27rem;
    height: 0.9rem;
    background: #3e73fe;
    border-radius: 0.08rem;
    .layout-flex(@r,@c,@c);
    font-weight: bold;
    color: #ffffff;
    font-size: 0.32rem;
  }
  .check_loading {
    width: 3.27rem;
    height: 0.9rem;
    background: #3e73fe;
    border-radius: 0.08rem;
    .layout-flex(@r,@c,@c);
    font-weight: bold;
    color: #ffffff;
    font-size: 0.32rem;
    .circle {
      width: 0.35rem;
      height: 0.35rem;
      background: conic-gradient(transparent 10%, #e4e4e4 90%);
      border-radius: 50%;
      position: relative;
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      0% {
        transform: rotate(0deg);
        /* 初始状态 */
      }

      100% {
        transform: rotate(360deg);
        /* 结束状态 */
      }
    }
  }
  .check_list {
    width: 6.85rem;
    height: 3.9rem;
    background: #f1f5f6;
    border-radius: 0.2rem;
    margin-top: 0.46rem;
    padding: 0 0.3rem;
    padding-top: 0.36rem;
    box-sizing: border-box;
    .layout-flex(@col,normal,normal);
    .end_text {
      font-size: 0.24rem;
      color: #656565;
      margin-bottom: 0.4rem;
    }
    .check_item {
      line-height: 0.48rem;
      .layout-flex(@r,normal,@c);
      span {
        font-size: 0.24rem;
        color: #656565;
        margin-right: 0.2rem;
        white-space: nowrap;
      }
      .check_status {
        width: 0.33rem;
        height: 0.33rem;
        flex-shrink: 0;
      }
      .status_1 {
        background: url('../assets/check_ed.png');
        background-size: 100% 100%;
      }
      .status_2 {
        background: url('../assets/check_no.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>